import { useTranslation } from 'react-i18next';
import classNames from './MyProgress.module.scss';
import classes from 'classnames';
import UseThemeColors from '@/hooks/UseThemeColors';
import commonUtils from '@/utils/common';
import { UnitsProgress } from '@/types/progress';
import { authSelector } from '@/store/reducers/auth';
import { useAppSelector } from '@/store';

import ProgressCard from '@/components/ProgressCard/ProgressCard';
import UseScreenSize from '@/hooks/UseScreenSize';

interface MyProgressProps {
  className?: string;
  unitsProgress: UnitsProgress | null;
  onProgressCardClick: (id: number) => void;
  // ELL-7749: true once the student's assigned level is at 100% progress and their
  // group's GroupSettings doesn't allow individually advancing past it - mirrors the
  // teacher/admin "completed level" notice already shown in DataContainer/StudentData.
  showCompletedNotice?: boolean;
}

const MyProgress = ({
  className,
  unitsProgress,
  onProgressCardClick,
  showCompletedNotice,
}: MyProgressProps) => {
  const { t } = useTranslation();
  const { color } = UseThemeColors();
  const { isMobile } = UseScreenSize();

  const { user } = useAppSelector(authSelector);

  const progressCards = unitsProgress
    ? Object.entries(unitsProgress).map(([key, value]) => {
        const { trailColor, pathColor } = commonUtils.getNewProgressColors(value.order) ?? {};
        const percentage = value.progress;

        const topics = {
          completed: value.completedTopics,
          total: value.totalTopics,
        };

        const activities = {
          completed: value.completedActivities,
          total: value.totalActivites,
        };

        return (
          <ProgressCard
            key={key}
            unitId={value.unitId}
            title={value.unitName}
            percentage={percentage}
            topics={topics}
            activities={activities}
            user={user}
            trailColor={color(trailColor ?? '') ?? ''}
            pathColor={color(pathColor ?? '') ?? ''}
            onClick={onProgressCardClick}
            className={isMobile ? classNames.progressCardMobile : ''}
            topicsClassName={classNames.progressCardTopics}
            showViewPerformanceBtn={!isMobile}
          />
        );
      })
    : null;

  return (
    <div className={classes(classNames.myProgress, className)}>
      {!isMobile && <h2>{t('myProgress')}</h2>}
      <div className={classNames.progressCards}>{progressCards}</div>
      {showCompletedNotice && (
        <p className={classNames.completedNotice}>{t('myProgressCompletedNotice')}</p>
      )}
    </div>
  );
};

export default MyProgress;
